import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPopoverModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { MuiButtonModule } from '../button';
import { MuiIconModule } from '../icon';
import { MuiPopoverModule } from '../popover';
import { MuiUtilityModule } from '../utility';
import { MuiAutocomplete } from './autocomplete/mui-autocomplete.component';
import { MuiCheckbox } from './checkbox/mui-checkbox.component';
import { MuiColorPickerModule } from './color-picker/mui-color-picker.module';
import { MuiDatepickerV2 } from './datepicker-v2/date-picker/mui-datepicker-v2.component';
import { MuiDateRangePicker } from './datepicker-v2/range-picker/mui-date-range-picker.component';
import { MuiDatepickerModule } from './datepicker/mui-datepicker.module';
import { MuiFileInput } from './file';
import { MuiFormFieldError } from './form-field/error/mui-form-field-error.component';
import { MuiFormFieldHint } from './form-field/hint/mui-form-field-hint.component';
import { MuiFormField } from './form-field/mui-form-field.component';
import { MuiFormFieldSubmit } from './form-field/submit/mui-form-field-submit.component';
import { MuiIconPicker } from './icon-picker/mui-icon-picker.component';
import { MuiIconToggleButton } from './icon-toggle-button/mui-icon-toggle-button.component';
import { MuiInputNativeDirective } from './input/mui-input-native.directive';
import { MuiInputDirective } from './input/mui-input.directive';
import { MuiOption } from './option/mui-option.component';
import { MuiPasswordChecker } from './password-checker/password-checker.component';
import { MuiRadioGroup } from './radio/mui-radio-group.component';
import { MuiSelect } from './select/mui-select.component';
import { MuiSwitch } from './switch/mui-switch.component';
import { MuiTextareaDirective } from './textarea/mui-textarea.directive';
import { MuiTimeInputDirective } from './time-input/mui-time-input.directive';
import { MuiVisibleTextValidator } from './validators/mui-visible-text-validator.directive';


@NgModule({
  declarations: [
    MuiAutocomplete,
    MuiCheckbox,
    MuiFormFieldError,
    MuiFormFieldHint,
    MuiFormFieldSubmit,
    MuiIconToggleButton,
    MuiIconPicker,
    MuiInputDirective,
    MuiOption,
    MuiPasswordChecker,
    MuiSelect,
    MuiSwitch,
    MuiRadioGroup,
    MuiTextareaDirective,
    MuiTimeInputDirective,
    MuiVisibleTextValidator
  ],
  exports: [
    FormsModule,
    MuiColorPickerModule,
    MuiFileInput,
    MuiFormField,
    MuiFormFieldError,
    MuiFormFieldHint,
    MuiInputDirective,
    MuiInputNativeDirective,
    MuiFormFieldSubmit,
    MuiCheckbox,
    MuiSwitch,
    MuiTextareaDirective,
    MuiVisibleTextValidator,
    MuiDatepickerModule,
    MuiDatepickerV2,
    MuiDateRangePicker,
    MuiTimeInputDirective,
    MuiOption,
    MuiSelect,
    MuiRadioGroup,
    MuiIconToggleButton,
    MuiPasswordChecker,
    MuiIconPicker,
    MuiAutocomplete
  ],
  imports: [
    CommonModule,
    FormsModule,
    A11yModule,
    MuiButtonModule,
    MuiColorPickerModule,
    MuiDatepickerV2,
    MuiDateRangePicker,
    MuiFileInput,
    MuiFormField,
    MuiInputNativeDirective,
    MuiIconModule,
    MuiPopoverModule,
    MuiUtilityModule,
    NgbPopoverModule,
    NgbTypeaheadModule
  ]
})
export class MuiFormsModule {}
